import React from 'react';
import StateTabs from 'src/components/StateTabs';

import BaseDrawer from '../ManagePerspective/Inspectors/BaseDrawer';
import RolesCardList from './RolesCardList';
import FieldsCardList from './FieldsCardList';


const tabs = [
  {
    route: 'roles',
    label: 'Roles',
    component: RolesCardList,
  },
  {
    route: 'fields',
    label: 'Fields',
    component: FieldsCardList,
  },
];

interface Props {
  workflowId: string,
}

const LeftDrawer = ({
  workflowId,
}: Props) => {
  const [currentTabRoute, setCurrentTabRoute] = React.useState(tabs[0].route);
  return (
    <BaseDrawer>
      <StateTabs
        tabs={tabs}
        currentTabRoute={currentTabRoute}
        setCurrentTabRoute={setCurrentTabRoute}
        componentProps={{
        // shared
          workflowId,
        }}
      />
    </BaseDrawer>
  );
};

export default LeftDrawer;
